import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { ControlsListComponent } from '@connect-services/client/components/controls-list/controls-list.component';
import { FieldInterventionFormEntityControlResultsComponent } from '@connect-services/client/components/field-intervention-form-entity-control-results/field-intervention-form-entity-control-results.component';
import { FieldInterventionFormEntityControlResultsHeaderComponent } from '@connect-services/client/components/field-intervention-form-entity-control-results/field-intervention-form-entity-control-results-header/field-intervention-form-entity-control-results-header.component';
import { FieldInterventionControlResultDetails } from '@connect-services/client/services/field-intervention.service';
import {
    FieldInterventionControlsGroup,
    JsonSchemaFieldInterventionFormControl,
} from '@connect-services/client/services/json-form.service';
import { ExpansionPanelComponent } from '@connect-services/src/lib/components/expansion-panel/expansion-panel.component';
import { FieldInterventionControlResult } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ControlsListComponent,
        ExpansionPanelComponent,
        FieldInterventionFormEntityControlResultsComponent,
        FieldInterventionFormEntityControlResultsHeaderComponent,
        LoadingComponent,
        RessourcesModule,
    ],
    selector: 'app-field-intervention-form-grouped-controls',
    templateUrl: './field-intervention-form-grouped-controls.component.html',
})
export class FieldInterventionFormGroupedControlsComponent {
    public readonly controlResults = input.required<FieldInterventionControlResultDetails[]>();
    public readonly controlsGroup = input.required<FieldInterventionControlsGroup>();
    public readonly isExpanded = input.required<boolean>();
    public readonly isLoading = input<boolean>(true);
    public readonly isResultRequired = input<boolean>(true);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly controlIds = computed<string[]>(
        () =>
            this.controlsGroup().controls.map(
                (control: JsonSchemaFieldInterventionFormControl): string => control.id,
            ) ?? [],
    );
    public readonly controlResultUpdated = output<FieldInterventionControlResult>();
    public readonly fieldInterventionControlResults = computed<FieldInterventionControlResultDetails[]>(() =>
        this.controlResults().filter((result: FieldInterventionControlResultDetails): boolean =>
            this.controlIds().includes(result.control),
        ),
    );
}
